import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const LiberarCredito = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState("");
  const [tipoErro, setTipoErro] = useState("");

  const [valor, setValor] = useState(null);
  const [maquina, setMaquina] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const carregar = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_SERVIDOR}/link/${id}`
        );

        setValor(res.data.valor);
        setMaquina(res.data.maquina);
        setStatus(res.data.status);

      } catch (err) {
        if (err.response?.data?.error === "Link já utilizado") {
          setTipoErro("usado");
        } else {
          setErro("Erro ao carregar link");
        }
      }
    };

    carregar();
  }, [id]);

  const liberar = async () => {
    try {
      setLoading(true);
      setErro("");
      setTipoErro("");

      await axios.post(
        `${process.env.REACT_APP_SERVIDOR}/usar-link/${id}`
      );

      setSucesso(true);

    } catch (err) {
      if (err.response?.data?.error === "Link inválido ou já usado") {
        setTipoErro("usado");

      } else if (err.response?.data?.msg === "MÁQUINA OFFLINE!") {
        setTipoErro("offline");

      } else {
        setErro("Erro ao liberar crédito");
      }

    } finally {
      setLoading(false);
    }
  };

  if (tipoErro === "usado") {
    return (
      <div style={styles.container}>
        <div style={styles.top}>
          Ikpay Sistema<br />
          <span style={styles.phone}>47 9 8486-1290</span>
        </div>

        <div style={styles.card}>
          <h1 style={styles.title}>🔒 Link já utilizado</h1>
        </div>
      </div>
    );
  }

  if (tipoErro === "offline") {
    return (
      <div style={styles.container}>
        <div style={styles.top}>
          Ikpay Sistema<br />
          <span style={styles.phone}>47 9 8486-1290</span>
        </div>

        <div style={styles.card}>
          <h1 style={styles.title}>🔌 Máquina offline</h1>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>

      {/* 🔝 TOPO */}
      <div style={styles.top}>
        Ikpay Sistema<br />
        <span style={styles.phone}>47 9 8486-1290</span>
      </div>

      {/* 🔥 CARD */}
      {!sucesso ? (
        <div style={styles.card}>
          <h1 style={styles.title}>Liberação de Crédito</h1>

          {maquina && <p style={styles.subTitle}>🏪 {maquina}</p>}

          {valor && (
            <div style={styles.valuePill}>
              <span style={styles.valueText}>💰 R$ {valor}</span>
            </div>
          )}

          {status && (
            <div
              style={{
                ...styles.statusPill,
                ...(status === "ONLINE" ? styles.statusOnline : styles.statusOffline),
              }}
            >
              {status === "ONLINE" ? "🟢 Online" : "🔌 Offline"}
            </div>
          )}

          <button
            onClick={liberar}
            disabled={loading || status === "OFFLINE"}
            style={{
              ...styles.button,
              ...(status === "OFFLINE" ? styles.buttonDisabled : styles.buttonEnabled),
            }}
          >
            {loading ? "⏳ Liberando..." : "💳 Liberar Crédito"}
          </button>

          {erro && <p style={styles.error}>❌ {erro}</p>}
        </div>
      ) : (
        <div style={styles.successCard}>
          <h1 style={styles.title}>✅ Crédito Liberado!</h1>
          <div style={styles.successSub}>Você pode fechar esta tela.</div>
        </div>
      )}

    </div>
  );
};

export default LiberarCredito;

const styles = {
  container: {
    height: "100vh",
    background: "var(--app-bg)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Sora, Segoe UI, Arial, sans-serif",
    padding: "24px",
  },

  top: {
    position: "absolute",
    top: 20,
    textAlign: "center",
    color: "#fff",
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 0.2,
  },

  phone: {
    fontSize: 16,
    fontWeight: "normal"
  },

  title: {
    margin: "0 0 14px",
    fontSize: 34,
    lineHeight: 1.1,
    letterSpacing: -0.3,
    color: "rgba(233, 242, 255, 0.97)",
  },

  subTitle: {
    margin: "0 0 14px",
    color: "rgba(233, 242, 255, 0.78)",
    fontSize: 15,
    lineHeight: 1.3,
  },

  card: {
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.06) 100%)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    color: "rgba(233, 242, 255, 0.92)",
    padding: "34px 26px",
    borderRadius: 16,
    textAlign: "center",
    width: 360,
    maxWidth: "92vw",
    backdropFilter: "blur(14px)",
    boxShadow: "0 18px 55px rgba(0,0,0,0.55), 0 0 0 1px rgba(0, 210, 255, 0.10) inset"
  },

  successCard: {
    background:
      "linear-gradient(180deg, rgba(0, 210, 255, 0.14) 0%, rgba(255, 255, 255, 0.06) 100%)",
    border: "1px solid rgba(0, 210, 255, 0.28)",
    color: "rgba(233, 242, 255, 0.92)",
    padding: "34px 26px",
    borderRadius: 16,
    textAlign: "center",
    width: 360,
    maxWidth: "92vw",
    backdropFilter: "blur(14px)",
    boxShadow: "0 18px 55px rgba(0,0,0,0.55), 0 0 0 1px rgba(0, 210, 255, 0.18) inset"
  },

  successSub: {
    marginTop: 10,
    color: "rgba(233, 242, 255, 0.78)",
    fontSize: 14,
  },

  valuePill: {
    margin: "10px 0 12px",
    padding: "10px 14px",
    borderRadius: 999,
    background: "rgba(0, 210, 255, 0.12)",
    border: "1px solid rgba(0, 210, 255, 0.22)",
  },

  valueText: {
    fontSize: 22,
    fontWeight: 800,
    color: "rgba(233, 242, 255, 0.98)",
  },

  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 0 16px",
    padding: "8px 14px",
    borderRadius: 999,
    fontWeight: 800,
    fontSize: 13,
    letterSpacing: 0.3,
  },

  statusOnline: {
    background: "rgba(34, 197, 94, 0.14)",
    border: "1px solid rgba(34, 197, 94, 0.30)",
    color: "rgba(233, 242, 255, 0.96)",
  },

  statusOffline: {
    background: "rgba(239, 68, 68, 0.14)",
    border: "1px solid rgba(239, 68, 68, 0.28)",
    color: "rgba(233, 242, 255, 0.96)",
  },

  button: {
    width: "100%",
    padding: "15px",
    fontSize: 18,
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 800,
    boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
    transition: "transform 120ms ease, filter 120ms ease",
  },

  buttonEnabled: {
    background: "var(--ik-gradient)",
  },

  buttonDisabled: {
    background: "rgba(255,255,255,0.14)",
    color: "rgba(233, 242, 255, 0.65)",
    cursor: "not-allowed",
    boxShadow: "none",
    filter: "saturate(0.7)",
  },

  error: {
    marginTop: 15,
    color: "red"
  }
};
